import { createFileRoute, Outlet } from '@tanstack/react-router'
import { LogoutButton } from '@/components/auth/logout-button'
import { RoleGuard } from '@/components/auth/role-guard'
import { BrandLogo } from '@/components/brand-logo'
import { ThemeToggle } from '@/components/theme-toggle'

export const Route = createFileRoute('/seller')({
  component: SellerLayout,
})

function SellerLayout() {
  return (
    <RoleGuard allowedRoles={['seller']}>
      <div className="min-h-dvh">
        <header className="flex items-center justify-between gap-4 border-b px-4 py-3">
          <div className="flex min-w-0 items-center gap-2.5">
            <BrandLogo />
            <span aria-hidden="true" className="text-muted-foreground/40">
              ·
            </span>
            <span className="truncate text-sm text-muted-foreground">Кабинет продавца</span>
          </div>
          <div className="flex items-center gap-1">
            <ThemeToggle />
            <LogoutButton />
          </div>
        </header>
        <Outlet />
      </div>
    </RoleGuard>
  )
}
